module.exports = __webpack_public_path__ + "img/特色功能.eb0f491a.png";